import React, { useEffect, useState } from "react";
import { IoFilter } from "react-icons/io5";
import { useGetEtapas } from "services/api/Etapas_Subetapas/etapas-get";
import {
  OrigemRequisicao,
  useGetSubetapas,
} from "services/api/Etapas_Subetapas/subetapas-get";
import { useTemperaturasLead } from "services/api/Mobile_Temperatura_Lead/temperaturas-lead";
import axiosLead from "services/lead";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { InputAdornment } from "@mui/material";
import RadioComponent from "components/RadioG";
import DatePickerRangeG from "components/DatePickerRangeG";
import { useMotivosDesquealificacao } from "services/api/AppWeb_Lead";
import SelectAutoCompleteMultiple from "components/SelectAutoCompleteMultipleG";
import { useListarObjetivosCompras } from "services/api/Mobile_ObjetivosCompras/objetivos-compras";
import { useTiposEmpreendimentos } from "services/api/Mobile_Tipos_Empreendimentos/tipos-empreendimentos";
import SelectAutoComplete from "components/selectAutoCompleteG";
import { useListarZonasEmpreendimentos } from "services/api/Mobile_Zonas_Empreendimentos/zonas_empreendimentos";
import { useListarPrazosEntregasImovel } from "services/api/Mobile_Prazos_Entrega_Imovel/prazos-entrega-imovel";
import ToggleBtns from "components/toggleBtns";
import { formatarInputMoeda } from "utils/formatReais";
import { useListarBairrosEmpreendimentos } from "services/api/AppWeb_Bairros_Empreendimentos/bairros_empreendimentos2";
import { useListarEmpreendimentos2 } from "services/api/AppWeb_Empreendimento2/empreendimentos2";
import { useListarOrigensLeads } from "services/api/Mobile_OrigemLead/origens-leads";
import { FilterData } from "../../types/filtros.types";
import * as S from "./styles";

interface Props {
  onCloseModal: () => void;
  onApplyFilters?: (filters: FilterData) => void;
  onClearFilters?: () => void;
  isOpen?: boolean;
}

const FilterDrawer: React.FC<Props> = ({
  onCloseModal,
  onApplyFilters,
  onClearFilters,
  isOpen = false,
}) => {
  const { idRegionalSistemaOrigem } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const {
    data: motivosDesqualificacao,
    refetch: motivosDesqualificacaoRefetch,
  } = useMotivosDesquealificacao({
    queryKey: "motivos_desqualificacao",
  });

  const motivosDesqualificacaoOptions =
    motivosDesqualificacao?.data?.map((motivo: any) => ({
      value: motivo.id,
      label: motivo.nome,
    })) || [];

  const { data: dataEntregaImovel, refetch: dataEntregaImovelRefetch } =
    useListarPrazosEntregasImovel();

  const prazoEntregaData =
    dataEntregaImovel?.data?.map((item: any) => ({
      value: item.id,
      label: item.nome,
    })) || [];

  const { data: dataObjetivosCompra, refetch: dataObjetivosCompraRefetch } =
    useListarObjetivosCompras();

  const objetivosCompraData =
    dataObjetivosCompra?.data?.map((item: any) => ({
      value: item.id,
      label: item.nome,
    })) || [];

  const {
    data: dataTiposEmpreendimentos,
    refetch: dataTiposEmpreendimentosRefetch,
  } = useTiposEmpreendimentos();

  const tipoEmpreendimentoData =
    dataTiposEmpreendimentos?.data?.map((item: any) => ({
      value: item.id,
      label: item.nome,
    })) || [];

  const {
    data: dataZonasEmpreendimentos,
    refetch: dataZonasEmpreendimentosRefetch,
  } = useListarZonasEmpreendimentos();

  const zonaData =
    dataZonasEmpreendimentos?.data?.map((item: any) => ({
      value: item.id,
      label: item.nome,
    })) || [];

  const {
    mutate: mutateBairrosEmpreendimentos,
    isLoading: isPendingBairrosEmpreendimentos,
  } = useListarBairrosEmpreendimentos();

  const { data: dataEmpreendimentos2, refetch: refetchEmpreendimentos2 } =
    useListarEmpreendimentos2();

  const { data: dataOrigens, refetch: refetchOrigens } = useListarOrigensLeads({
    filtro: true,
  });

  const { data: dataEtapa, refetch: refetchEtapas } = useGetEtapas();

  const {
    data: dataTemperatura,
    refetch: refetchTemperatura,
    status: statusTemperatura,
  } = useTemperaturasLead();

  const [bairroData, setBairroData] = useState<any[]>([]);
  const [canaisData, setCanaisData] = useState<any[]>([]);
  const [loadingCanais, setLoadingCanais] = useState<boolean>(false);

  useEffect(() => {
    // Só faz as requisições quando o drawer é aberto
    if (isOpen) {
      motivosDesqualificacaoRefetch();
      dataObjetivosCompraRefetch();
      dataTiposEmpreendimentosRefetch();
      dataZonasEmpreendimentosRefetch();
      dataEntregaImovelRefetch();
      refetchEmpreendimentos2();
      refetchOrigens();
      refetchEtapas();
      refetchTemperatura();
    }
  }, [
    isOpen,
    motivosDesqualificacaoRefetch,
    dataObjetivosCompraRefetch,
    dataTiposEmpreendimentosRefetch,
    dataZonasEmpreendimentosRefetch,
    dataEntregaImovelRefetch,
    refetchEmpreendimentos2,
    refetchOrigens,
    refetchEtapas,
    refetchTemperatura,
  ]);

  const quantidadeVezesData = [
    { value: "1", label: "1 vez" },
    { value: "2", label: "2 vezes" },
    { value: "3", label: "3 vezes" },
    { value: "4", label: "4+ vezes" },
  ];

  const origemData =
    dataOrigens?.data?.map((item: any) => ({
      value: item.id,
      label: item.nome,
    })) || [];

  const requestCanaisContato = async (idsOrigem: string[]) => {
    if (!idsOrigem || idsOrigem.length === 0) {
      setCanaisData([]);
      return;
    }

    setLoadingCanais(true);
    try {
      const response = await axiosLead.GetCanaisContato(idsOrigem);
      const { data } = response.data;

      setCanaisData(
        data.map((item: { nome: string; id: string }) => ({
          label: item.nome,
          value: item.id,
        }))
      );
    } catch (error: any) {
      console.log(
        error?.response?.data?.notifications
          ? error?.response?.data?.notifications?.map(
              (item: any) => `${item.message}\n`
            )
          : "Erro ao listar canais de contato."
      );
      setCanaisData([]);
    } finally {
      setLoadingCanais(false);
    }
  };

  const rendaFamiliarData = [
    { value: "1", label: "Até R$ 5.000" },
    { value: "2", label: "R$ 5.001 - R$ 10.000" },
    { value: "3", label: "R$ 10.001 - R$ 15.000" },
    { value: "4", label: "Acima de R$ 15.000" },
  ];

  // Filtra apenas o Bolsão da resposta da API
  const bolsaoFromApi = dataEtapa?.find((item: any) => item.nome === "Bolsão");

  const bolsaoId = bolsaoFromApi?.id || null;

  const etapaData = bolsaoFromApi
    ? [
        {
          value: bolsaoFromApi.id,
          label: bolsaoFromApi.nome,
        },
      ]
    : [];

  // Todas as etapas para Etapa Anterior (sem filtro de Bolsão)
  const etapaAnteriorData =
    dataEtapa?.map((item: any) => ({
      value: item.id,
      label: item.nome,
    })) || [];

  const produtoInteresseData =
    dataEmpreendimentos2?.data?.map((item: any) => ({
      value: item.id,
      label: item.nome,
    })) || [];

  const dormitoriosData = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4+" },
  ];

  const temperaturaData =
    dataTemperatura?.data?.map((item: { nome: string; id: string }) => ({
      value: item.id,
      label: item.nome,
    })) || [];
  const [filters, setFilters] = useState<FilterData>({
    filtrarPor: null,
    inicioIntervaloCadastroLead: null,
    fimIntervaloCadastroLead: null,
    inicioIntervaloAtualizacaoLead: null,
    fimIntervaloAtualizacaoLead: null,
    idsMotivosDesqualificacaoLeadSistemaOrigem: [],
    leadCliente: null,
    leadVisitouEmpreendimento: null,
    leadPassouPelaOfertaAtiva: null,
    quantidadeVezesLeadPassouPelaOfertaAtiva: null,
    idsOrigensLeadSistemaOrigem: null,
    idsCanaisLeadSistemaOrigem: null,
    idsTemperaturasLeadSistemaOrigem: [],
    idsRendasFamiliaresLeadSistemaOrigem: null,
    etapas: [],
    idsSubetapasSistemaOrigem: null,
    etapasAnterioresLead: [],
    idsSubEtapasAnterioresLeadSistemaOrigem: [],
    idsProdutosInteresseSistemaOrigem: [],
    apenasLeadsSemProdutos: false,
    idsTiposEmpreendimentosSistemaOrigem: [],
    quantidadesDormitorios: [],
    idsZonasEmpreendimentosSistemaOrigem: [],
    idsBairrosEmpreendimentosSistemaOrigem: [],
    inicioIntervaloValorImovel: "",
    fimIntervaloValorImovel: "",
    idsObjetivosCompraSistemaOrigem: [],
    idsPrazosEntregaSistemaOrigem: [],
  });

  const getEtapasParaSubetapas = () => {
    if (filters.etapas.length > 0) {
      return filters.etapas;
    }
    if (bolsaoId) {
      return [bolsaoId];
    }
    return [];
  };

  const etapasParaSubetapas = getEtapasParaSubetapas();

  const {
    data: dataSubEtapa,
    refetch: refetchSubEtapa,
    isFetching: isFetchingSubEtapa,
  } = useGetSubetapas({
    idsEtapas: etapasParaSubetapas,
    idRegional: idRegionalSistemaOrigem,
    OrigemRequisicao: OrigemRequisicao.FiltroCriacaoOfertaAtiva,
    queryKeySuffix: "normal",
  });

  const subetapasData = dataSubEtapa
    ? dataSubEtapa?.subEtapas?.map((item: any) => ({
        value: item.id,
        label: item.nome,
      })) || []
    : [];

  // Requisição de subetapas para etapas anteriores
  const {
    data: dataSubEtapaAnterior,
    refetch: refetchSubEtapaAnterior,
    isFetching: isFetchingSubEtapaAnterior,
  } = useGetSubetapas({
    idsEtapas: filters.etapasAnterioresLead,
    idRegional: idRegionalSistemaOrigem,
    queryKeySuffix: "anterior",
  });

  const subetapasAnterioresData = dataSubEtapaAnterior
    ? dataSubEtapaAnterior?.subEtapas?.map((item: any) => ({
        value: item.id,
        label: item.nome,
      })) || []
    : [];

  const handleClearFilters = () => {
    setFilters({
      filtrarPor: null,
      inicioIntervaloCadastroLead: null,
      fimIntervaloCadastroLead: null,
      inicioIntervaloAtualizacaoLead: null,
      fimIntervaloAtualizacaoLead: null,
      idsMotivosDesqualificacaoLeadSistemaOrigem: [],
      leadCliente: null,
      leadVisitouEmpreendimento: null,
      leadPassouPelaOfertaAtiva: null,
      quantidadeVezesLeadPassouPelaOfertaAtiva: null,
      idsOrigensLeadSistemaOrigem: null,
      idsCanaisLeadSistemaOrigem: null,
      idsTemperaturasLeadSistemaOrigem: [],
      idsRendasFamiliaresLeadSistemaOrigem: null,
      etapas: bolsaoId ? [bolsaoId] : [],
      idsSubetapasSistemaOrigem: null,
      etapasAnterioresLead: [],
      idsSubEtapasAnterioresLeadSistemaOrigem: [],
      idsProdutosInteresseSistemaOrigem: [],
      apenasLeadsSemProdutos: false,
      idsTiposEmpreendimentosSistemaOrigem: [],
      quantidadesDormitorios: [],
      idsZonasEmpreendimentosSistemaOrigem: [],
      idsBairrosEmpreendimentosSistemaOrigem: [],
      inicioIntervaloValorImovel: "",
      fimIntervaloValorImovel: "",
      idsObjetivosCompraSistemaOrigem: [],
      idsPrazosEntregaSistemaOrigem: [],
    });
    onClearFilters?.();
  };

  const handleApplyFilters = () => {
    onApplyFilters?.(filters);
    onCloseModal();
  };

  const handleFiltrarPorChange = (value: "criacao" | "atualizacao") => {
    setFilters((prev) => ({
      ...prev,
      filtrarPor: prev.filtrarPor === value ? null : value,
      // Limpa as datas quando muda o tipo de filtro
      inicioIntervaloCadastroLead: null,
      fimIntervaloCadastroLead: null,
      inicioIntervaloAtualizacaoLead: null,
      fimIntervaloAtualizacaoLead: null,
    }));
  };

  // Monitora mudanças na origem para buscar canais correspondentes
  useEffect(() => {
    if (filters.idsOrigensLeadSistemaOrigem) {
      const idsOrigem = [filters.idsOrigensLeadSistemaOrigem.value];
      requestCanaisContato(idsOrigem);
    } else {
      setCanaisData([]);
    }
  }, [filters.idsOrigensLeadSistemaOrigem]);

  // Inicializa com Bolsão selecionado quando os dados chegarem
  useEffect(() => {
    if (bolsaoId && filters.etapas.length === 0) {
      setFilters((prev) => ({
        ...prev,
        etapas: [bolsaoId],
      }));
    }
  }, [bolsaoId]);

  // Monitora mudanças nas etapas para buscar subetapas correspondentes
  useEffect(() => {
    if (etapasParaSubetapas.length > 0) {
      refetchSubEtapa();
    }
  }, [filters.etapas, bolsaoId, refetchSubEtapa]);

  // Monitora mudanças nas etapas anteriores para buscar subetapas correspondentes
  useEffect(() => {
    if (
      filters.etapasAnterioresLead &&
      filters.etapasAnterioresLead.length > 0
    ) {
      refetchSubEtapaAnterior();
    }
  }, [filters.etapasAnterioresLead, refetchSubEtapaAnterior]);

  return (
    <S.Container>
      <S.HeaderModal>
        <S.FilterIcon>
          <IoFilter />
        </S.FilterIcon>
        <S.HeaderModalTitle>Filtros</S.HeaderModalTitle>
        <S.ClearBtn onClick={handleClearFilters}>Limpar</S.ClearBtn>
      </S.HeaderModal>

      <S.ContentModal>
        <S.LabelModal>Filtrar por</S.LabelModal>
        <S.RadioGroup>
          <S.FormControlLabel
            value="criacao"
            control={<S.Radio />}
            label="Data criação"
            checked={filters.filtrarPor === "criacao"}
            onChange={() => handleFiltrarPorChange("criacao")}
          />
          <S.FormControlLabel
            value="atualizacao"
            control={<S.Radio />}
            label="Data atualização"
            checked={filters.filtrarPor === "atualizacao"}
            onChange={() => handleFiltrarPorChange("atualizacao")}
          />
        </S.RadioGroup>

        <DatePickerRangeG
          startDate={
            filters.filtrarPor === "criacao"
              ? filters.inicioIntervaloCadastroLead
              : filters.inicioIntervaloAtualizacaoLead
          }
          endDate={
            filters.filtrarPor === "criacao"
              ? filters.fimIntervaloCadastroLead
              : filters.fimIntervaloAtualizacaoLead
          }
          onStartDateChange={(date) =>
            setFilters((prev) => ({
              ...prev,
              ...(prev.filtrarPor === "criacao"
                ? { inicioIntervaloCadastroLead: date }
                : { inicioIntervaloAtualizacaoLead: date }),
            }))
          }
          onEndDateChange={(date) =>
            setFilters((prev) => ({
              ...prev,
              ...(prev.filtrarPor === "criacao"
                ? { fimIntervaloCadastroLead: date }
                : { fimIntervaloAtualizacaoLead: date }),
            }))
          }
          disabled={!filters.filtrarPor}
        />

        <S.LabelText style={{ marginTop: 16 }}>
          Motivos Desqualificação
        </S.LabelText>
        <SelectAutoCompleteMultiple
          data={motivosDesqualificacaoOptions}
          value={filters.idsMotivosDesqualificacaoLeadSistemaOrigem}
          onChange={(event, value) =>
            setFilters((prev) => ({
              ...prev,
              idsMotivosDesqualificacaoLeadSistemaOrigem: value || [],
            }))
          }
          label=""
          placeholder="Selecione"
          borderRadius="8px"
        />

        <S.DividerLine>
          <S.DividerText>Características do Lead</S.DividerText>
        </S.DividerLine>

        <S.LabelText>Lead é cliente?</S.LabelText>
        <S.RadioGroup>
          <S.FormControlLabel
            value="sim"
            control={<S.Radio />}
            label="Sim"
            checked={filters.leadCliente === "sim"}
            onChange={() =>
              setFilters((prev) => ({
                ...prev,
                leadCliente: prev.leadCliente === "sim" ? null : "sim",
              }))
            }
          />
          <S.FormControlLabel
            value="nao"
            control={<S.Radio />}
            label="Não"
            checked={filters.leadCliente === "nao"}
            onChange={() =>
              setFilters((prev) => ({
                ...prev,
                leadCliente: prev.leadCliente === "nao" ? null : "nao",
              }))
            }
          />
        </S.RadioGroup>

        <S.LabelText>Visitou o empreendimento?</S.LabelText>
        <S.RadioGroup>
          <S.FormControlLabel
            value="sim"
            control={<S.Radio />}
            label="Sim"
            checked={filters.leadVisitouEmpreendimento === "sim"}
            onChange={() =>
              setFilters((prev) => ({
                ...prev,
                leadVisitouEmpreendimento:
                  prev.leadVisitouEmpreendimento === "sim" ? null : "sim",
              }))
            }
          />
          <S.FormControlLabel
            value="nao"
            control={<S.Radio />}
            label="Não"
            checked={filters.leadVisitouEmpreendimento === "nao"}
            onChange={() =>
              setFilters((prev) => ({
                ...prev,
                leadVisitouEmpreendimento:
                  prev.leadVisitouEmpreendimento === "nao" ? null : "nao",
              }))
            }
          />
        </S.RadioGroup>

        <S.LabelText>Passou pela Oferta Ativa?</S.LabelText>
        <S.RadioGroup>
          <S.FormControlLabel
            value="sim"
            control={<S.Radio />}
            label="Sim"
            checked={filters.leadPassouPelaOfertaAtiva === "sim"}
            onChange={() =>
              setFilters((prev) => ({
                ...prev,
                leadPassouPelaOfertaAtiva:
                  prev.leadPassouPelaOfertaAtiva === "sim" ? null : "sim",
              }))
            }
          />
          <S.FormControlLabel
            value="nao"
            control={<S.Radio />}
            label="Não"
            checked={filters.leadPassouPelaOfertaAtiva === "nao"}
            onChange={() =>
              setFilters((prev) => ({
                ...prev,
                leadPassouPelaOfertaAtiva:
                  prev.leadPassouPelaOfertaAtiva === "nao" ? null : "nao",
              }))
            }
          />
        </S.RadioGroup>

        <S.LabelText style={{ marginTop: 16 }}>
          Quantidade de vezes que passou na Oferta Ativa
        </S.LabelText>
        <SelectAutoComplete
          data={quantidadeVezesData}
          value={filters.quantidadeVezesLeadPassouPelaOfertaAtiva}
          onChange={(value: { value: string; label: string } | null) =>
            setFilters((prev) => ({
              ...prev,
              quantidadeVezesLeadPassouPelaOfertaAtiva: value,
            }))
          }
          placeholder="Selecione"
          borderRadius="8px"
        />

        <S.LabelText style={{ marginTop: 16 }}>Origem</S.LabelText>
        <SelectAutoCompleteMultiple
          data={origemData}
          value={
            filters.idsOrigensLeadSistemaOrigem
              ? [filters.idsOrigensLeadSistemaOrigem]
              : []
          }
          onChange={(event: any, value: any) => {
            const selectedValue = value && value.length > 0 ? value[0] : null;
            setFilters((prev) => ({
              ...prev,
              idsOrigensLeadSistemaOrigem: selectedValue,
              // Limpa o canal quando muda a origem
              idsCanaisLeadSistemaOrigem: null,
            }));
          }}
          label=""
          placeholder="Selecione"
          borderRadius="8px"
        />

        <S.LabelText style={{ marginTop: 16 }}>Canal</S.LabelText>
        <SelectAutoCompleteMultiple
          data={canaisData}
          value={
            filters.idsCanaisLeadSistemaOrigem
              ? [filters.idsCanaisLeadSistemaOrigem]
              : []
          }
          onChange={(event: any, value: any) => {
            const selectedValue = value && value.length > 0 ? value[0] : null;
            setFilters((prev) => ({
              ...prev,
              idsCanaisLeadSistemaOrigem: selectedValue,
            }));
          }}
          disabled={!filters.idsOrigensLeadSistemaOrigem || loadingCanais}
          label=""
          placeholder={loadingCanais ? "Carregando..." : "Selecione"}
          borderRadius="8px"
        />

        <S.LabelModal style={{ marginTop: 16 }}>Temperatura</S.LabelModal>
        {statusTemperatura === "success" ? (
          <ToggleBtns
            data={temperaturaData}
            value={filters.idsTemperaturasLeadSistemaOrigem}
            onChange={(newValues: string[]) => {
              setFilters((prev) => ({
                ...prev,
                idsTemperaturasLeadSistemaOrigem: newValues,
              }));
            }}
          />
        ) : (
          <div style={{ height: 40, background: "#f5f5f5", borderRadius: 8 }} />
        )}

        <S.LabelText style={{ marginTop: 16 }}>Renda familiar</S.LabelText>
        <SelectAutoComplete
          data={rendaFamiliarData}
          value={filters.idsRendasFamiliaresLeadSistemaOrigem}
          onChange={(value: { value: string; label: string } | null) =>
            setFilters((prev) => ({
              ...prev,
              idsRendasFamiliaresLeadSistemaOrigem: value,
            }))
          }
          placeholder="Selecione"
          borderRadius="8px"
        />

        <S.DividerLine>
          <S.DividerText>Etapas</S.DividerText>
        </S.DividerLine>

        <S.LabelText>Etapa</S.LabelText>
        <ToggleBtns
          data={etapaData}
          value={etapasParaSubetapas}
          onChange={(newValues: string[]) => {
            // Sempre mantém o Bolsão selecionado
            const etapasFinais =
              bolsaoId && !newValues.includes(bolsaoId)
                ? [...newValues, bolsaoId]
                : newValues;

            setFilters((prev) => ({
              ...prev,
              etapas: etapasFinais,
              // Limpa as subetapas quando muda as etapas
              idsSubetapasSistemaOrigem: null,
            }));
          }}
        />

        <S.LabelText style={{ marginTop: 16 }}>Subetapas</S.LabelText>
        <SelectAutoCompleteMultiple
          data={subetapasData}
          value={
            filters.idsSubetapasSistemaOrigem
              ? [filters.idsSubetapasSistemaOrigem]
              : []
          }
          onChange={(event: any, value: any) => {
            const selectedValue = value && value.length > 0 ? value[0] : null;
            setFilters((prev) => ({
              ...prev,
              idsSubetapasSistemaOrigem: selectedValue,
            }));
          }}
          disabled={
            !filters.etapas || filters.etapas.length === 0 || isFetchingSubEtapa
          }
          label=""
          placeholder={isFetchingSubEtapa ? "Carregando..." : "Selecione"}
          borderRadius="8px"
        />

        <S.LabelText style={{ marginTop: 16 }}>Etapa Anterior</S.LabelText>
        <ToggleBtns
          data={etapaAnteriorData}
          value={filters.etapasAnterioresLead}
          onChange={(newValues: string[]) => {
            setFilters((prev) => ({
              ...prev,
              etapasAnterioresLead: newValues,
              // Limpa as subetapas anteriores quando muda as etapas anteriores
              idsSubEtapasAnterioresLeadSistemaOrigem: [],
            }));
          }}
        />

        <S.LabelText style={{ marginTop: 16 }}>Subetapa Anterior</S.LabelText>
        <SelectAutoCompleteMultiple
          data={subetapasAnterioresData}
          value={filters.idsSubEtapasAnterioresLeadSistemaOrigem || []}
          onChange={(event: any, value: any) => {
            setFilters((prev) => ({
              ...prev,
              idsSubEtapasAnterioresLeadSistemaOrigem: value || [],
            }));
          }}
          disabled={
            !filters.etapasAnterioresLead ||
            filters.etapasAnterioresLead.length === 0 ||
            isFetchingSubEtapaAnterior
          }
          label=""
          placeholder={
            isFetchingSubEtapaAnterior ? "Carregando..." : "Selecione"
          }
          borderRadius="8px"
        />

        <S.DividerLine>
          <S.DividerText>Preferências do Lead</S.DividerText>
        </S.DividerLine>

        <S.LabelText>Produto de interesse</S.LabelText>
        <SelectAutoCompleteMultiple
          data={produtoInteresseData}
          value={filters.idsProdutosInteresseSistemaOrigem}
          onChange={(event: any, value: any) =>
            setFilters((prev: any) => ({
              ...prev,
              idsProdutosInteresseSistemaOrigem: value || [],
            }))
          }
          placeholder="Selecione"
          borderRadius="8px"
          label=""
        />

        <S.FormControlLabel
          className="switch-control"
          control={
            <S.Switch
              checked={filters.apenasLeadsSemProdutos}
              onChange={() =>
                setFilters((prev) => ({
                  ...prev,
                  apenasLeadsSemProdutos: !prev.apenasLeadsSemProdutos,
                }))
              }
            />
          }
          label="Visualizar apenas leads sem produtos"
          labelPlacement="start"
        />

        <S.LabelText style={{ marginTop: 16 }}>
          Tipo de empreendimento
        </S.LabelText>
        <ToggleBtns
          data={tipoEmpreendimentoData}
          value={filters.idsTiposEmpreendimentosSistemaOrigem}
          onChange={(newValues: string[]) => {
            setFilters((prev) => ({
              ...prev,
              idsTiposEmpreendimentosSistemaOrigem: newValues,
            }));
          }}
        />

        <S.LabelText style={{ marginTop: 16 }}>
          Dormitórios (Quartos)
        </S.LabelText>
        <ToggleBtns
          data={dormitoriosData}
          value={filters.quantidadesDormitorios}
          onChange={(newValues: string[]) => {
            setFilters((prev) => ({
              ...prev,
              quantidadesDormitorios: newValues,
            }));
          }}
        />

        <S.LabelText style={{ marginTop: 16 }}>Zona</S.LabelText>
        <ToggleBtns
          data={zonaData}
          value={filters.idsZonasEmpreendimentosSistemaOrigem}
          onChange={(newValues: string[]) => {
            setFilters((prev) => ({
              ...prev,
              idsZonasEmpreendimentosSistemaOrigem: newValues,
            }));
            if (newValues.length === 0) {
              setFilters((prev) => ({
                ...prev,
                idsBairrosEmpreendimentosSistemaOrigem: [],
              }));
            }
            mutateBairrosEmpreendimentos(
              {
                idsZonasEmpreendimento: newValues,
              },
              {
                onSuccess: (response) => {
                  setBairroData(response?.data?.data || []);
                },
                onError: (error) => {
                  console.error("Erro ao carregar bairros:", error);
                  setBairroData([]);
                },
              }
            );
          }}
        />

        <S.LabelText style={{ marginTop: 16 }}>Bairro</S.LabelText>
        <SelectAutoCompleteMultiple
          data={
            Array.isArray(bairroData)
              ? bairroData
                  .filter((item: any) => item && item.idBairro && item.nome)
                  .map((item: any) => ({
                    value: item.idBairro,
                    label: item.nome,
                  }))
              : []
          }
          value={filters.idsBairrosEmpreendimentosSistemaOrigem}
          onChange={(event, value) =>
            setFilters((prev) => ({
              ...prev,
              idsBairrosEmpreendimentosSistemaOrigem: value || [],
            }))
          }
          disabled={
            filters.idsZonasEmpreendimentosSistemaOrigem.length === 0 ||
            isPendingBairrosEmpreendimentos
          }
          label=""
          placeholder="Selecione"
          borderRadius="8px"
        />

        <S.LabelModal style={{ marginTop: 16, marginBottom: 16 }}>
          Valor do imóvel
        </S.LabelModal>
        <S.Row style={{ alignItems: "center" }}>
          <S.TextField
            value={filters.inicioIntervaloValorImovel}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const formattedValue = formatarInputMoeda(e.target.value);
              setFilters((prev) => ({
                ...prev,
                inicioIntervaloValorImovel: formattedValue,
              }));
            }}
            variant="outlined"
            placeholder="R$ 0,00"
          />
          <S.TextCenter>até</S.TextCenter>
          <S.TextField
            value={filters.fimIntervaloValorImovel}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const formattedValue = formatarInputMoeda(e.target.value);
              setFilters((prev) => ({
                ...prev,
                fimIntervaloValorImovel: formattedValue,
              }));
            }}
            variant="outlined"
            placeholder="R$ 0,00"
          />
        </S.Row>

        <S.LabelText style={{ marginTop: 16 }}>Objetivos da compra</S.LabelText>
        <ToggleBtns
          data={objetivosCompraData}
          value={filters.idsObjetivosCompraSistemaOrigem}
          onChange={(newValues: string[]) => {
            setFilters((prev) => ({
              ...prev,
              idsObjetivosCompraSistemaOrigem: newValues,
            }));
          }}
        />

        <S.LabelText style={{ marginTop: 16 }}>Prazo de entrega</S.LabelText>
        <ToggleBtns
          data={prazoEntregaData}
          value={filters.idsPrazosEntregaSistemaOrigem}
          onChange={(newValues: string[]) => {
            setFilters((prev) => ({
              ...prev,
              idsPrazosEntregaSistemaOrigem: newValues,
            }));
          }}
        />
      </S.ContentModal>

      <S.FooterModal>
        <S.Button onClick={handleApplyFilters}>Aplicar filtros</S.Button>
      </S.FooterModal>
    </S.Container>
  );
};

export default FilterDrawer;
